var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"none"},attrs:{"id":"videoContainer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }